module.exports = __webpack_public_path__ + "img/letters.84551664.png";